import React, { useEffect, useState } from 'react'
import Banner from '../../../components/SlideBanner/Banner'
import './NewLogin.scoped.scss'
import LineLogo from "../../../img/vendors/icon/line.png";
import GoogleLogo from "../../../img/vendors/icon/google.png";
import FacebookLogo from "../../../img/vendors/icon/facebook.png";
import { EyeOutlined, EyeInvisibleOutlined } from "@ant-design/icons";
import { useHistory, useLocation } from 'react-router-dom';
import { apiClient, urlgetip, urlClientInfo } from "../../../api";
import {
  set_cookie,
  getExpiredDate,
  parseJwt
} from "../../../config";
import queryString from "query-string";
import { Col, Spin } from 'antd';
import TwoFactor from './components/twoFactor';
import ModalBroadCastWarning from '../../../components/Ants/Modal/ModalBroadCastWarning';
import ChangePassword from './components/changePassword';

const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768); // threshold for mobile

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isMobile;
}


const NewLogin = () => {
  const isMobile = useIsMobile();
  const [form, setForm] = useState({ username: '', password: '' });
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [clientInfo, setClientInfo] = useState("");
  const [ip, setIp] = useState("");
  const [loading, setLoading] = useState(false)
  const [platformEnv, setPlatformEnv] = useState(null);
  const [token, setToken] = useState("");
  const [cookie, setCookie] = useState("");
  const [email, setEmail] = useState("");
  const [statusTwoFactor, setStatusTwoFactor] = useState(false);
  const [errormessage, setErrormessage] = useState("");
  const [model, setModel] = useState({
    contactName: "",
    email: "",
    password: "",
    confirmPassword: "",
    recaptchaToken: null,
    OTPcode: "",
    OTPref: "",
    OTPid: "",
    typeUser: 1,
    consent: false
  });
  const [warningModalVisible, setWarningModalVisible] = useState(false);
  const [warningModalMessage, setWarningModalMessage] = useState("");
  const [warningModalOk, setWarningModalOk] = useState(() => () => setWarningModalVisible(false));
  const [warningModalCancel, setWarningModalCancel] = useState(() => () => setWarningModalVisible(false));
  const [statusDefaultPassword, setStatusDefaultPassword] = useState(false);
  const history = useHistory();

  const type = localStorage.getItem('type');
  const pid = localStorage.getItem('pid');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    setError('');
  };

  const getCookie = (cname) => {
    var name = cname + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }

      if (c.indexOf(name) == 0) {
        if (name == "__AntiXsrfUerkey=") {
          if (pid === undefined) {
            if (
              queryString.parse(this.props.location.search).oid === undefined &&
              queryString.parse(this.props.location.search).rid === undefined
            ) {
              this.setUrl("/home");
            } else if (queryString.parse(this.props.location.search).oid != undefined) {
              history.push(`/RequestTaxInfo?type=${type}&pid=${pid}`);
            } else if (queryString.parse(this.props.location.search).rid != undefined) {

              history.push("/OrderSummary" + this.props.location.search);
            } else {

              history.push("/404");
            }
          } else {
            history.push(`/RequestTaxInfo?type=${type}&pid=${pid}`);
          }
        }
      }
    }
    return "";
  }

  const utilIp = () => {
    urlgetip
      .get("", {
        headers: { "Content-type": "application/json; charset=UTF-8" },
      })
      .then((data) => {
        var json = data.data;
        setIp(json);
      })
      .catch((error) => {
        setIp("");
      });
  }

  const getClientInfo = () => {
    urlClientInfo
      .get("", {
        headers: { "Content-type": "application/json; charset=UTF-8" },
      })
      .then((data) => {
        var json = data.data;
        setClientInfo(JSON.stringify(json))
      })
      .catch((error) => {
        setClientInfo(JSON.stringify(""))
      });
  }

  const handleLogin = async (e) => {

    e.preventDefault();
    setLoading(true)
    if (!form.username.trim() || !form.password.trim()) {
      setError('กรุณากรอกชื่อผู้ใช้และรหัสผ่าน');
      return;
    }

    // Proceed with login logic here
    setError('');
    let req = JSON.stringify({
      "username": form.username.trim(),
      "password": form.password.trim(),
      "expireMinutes": "60",
      "ip": ip,
      "device": clientInfo,
    });

    const domain = window.location.origin;
    await apiClient.post('api/Token', req,
      {
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
          'X-Client-Domain': domain
        }
      })
      .then(data => {
        var json = data;
        let Token = "__AntiXsrfUerkey=" + encodeURIComponent(json.data);
        let ExpiredDate = getExpiredDate(Token).toGMTString();
        let SendToken = Token + ";expires=" + ExpiredDate + ";path=/";

        var tokenReplace = SendToken.replace(/(?:(?:^|.*;\s*)__AntiXsrfUerkey\s*\=\s*([^;]*).*$)|^.*$/, "$1");
        var payload = parseJwt(tokenReplace);

        setCookie(Token)
        setToken(json.data)

        if (payload.defaultPassword === "True") {
          handelDefaultPassword(payload, json.data)
        } else if (payload.twofactor === "True") {
          handleTwoFactor(payload, SendToken, json.data);
        } else {
          set_cookie(SendToken);

          if (pid) {
            history.push(`/RequestTaxInfo?type=${type}&pid=${pid}`);
          } else {
            history.push("/home");
          }
        }
        setLoading(false)
      })
      .catch(error => {
        console.log(error);
        setError('Username or Password is incorrect.');
        setLoading(false)
      });
  };

  const handleTwoFactor = (payload, SendToken, jsonData) => {
    if (payload.twofactor_7day === "True") {
      if (payload.twofactor_7day_last_date) {
        const lastDate = new Date(payload.twofactor_7day_last_date);
        const currentDate = new Date();
        lastDate.setHours(0, 0, 0, 0);
        currentDate.setHours(0, 0, 0, 0);

        const diffTime = currentDate - lastDate;
        const diffDays = diffTime / (1000 * 60 * 60 * 24);
        if (diffDays >= 7) {
          handleRequestOTP(jsonData);
        } else {
          set_cookie(SendToken);
          history.push("/home");
        }
      }
    } else {
      handleRequestOTP(jsonData);
    }
    setLoading(false);
  }

  const handleRequestOTP = async (jsonData) => {
    setStatusTwoFactor(true);
    let req = JSON.stringify({});

    await apiClient.post('api/RequestOTP', req
      , {
        headers: {
          'Authorization': `Bearer ${jsonData}`,
          'Content-type': 'application/json; charset=UTF-8'
        }
      })
      .then(data => {
        if (data.status === 200) {
          setModel({
            ...model,
            OTPid: data.data.data
          });
        }
      })
      .catch(error => {
        setLoading(false);
        setWarningModalVisible(true);
        setWarningModalMessage("Failed to request OTP.");
      });
  }

  const handleVerifyOTP = async (e) => {
    e.preventDefault();
    setLoading(true);

    let req = JSON.stringify({
      "otpid": model.OTPid,
      "otpcode": model.OTPcode,
      "noti7day": model.consent
    });

    await apiClient.post('api/Verify_OTP', req
      , {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-type': 'application/json; charset=UTF-8'
        }
      })
      .then(data => {
        if (data.status === 200) {
          if (data.data.result) {
            set_cookie(cookie);
            setLoading(false);
            setStatusTwoFactor(false)

            setTimeout(() => {
              if (pid) {
                history.push(`/RequestTaxInfo?type=${type}&pid=${pid}`);
              } else {
                history.push("/home");
              }
            }, 2000);
          } else {
            setErrormessage('Invalid OTP Provide!');
            setErrormessage('Invalid OTP Provide!');
            if (data.data.isErrorCount) {
              setErrormessage('You have reached OTP limit, please resend.');
            }
            if (data.data.isExprCode) {
              setErrormessage('OTP Time out!');
            }
            setLoading(false);
          }
        }
      })
      .catch(error => {
        console.log('error', error)
        setLoading(false);
      });
  }


  const handelDefaultPassword = (payload, jsonData) => {
    setEmail(payload.email)
    forgotpwd(payload.unique_name, payload.primarysid, payload.email, jsonData)
    setLoading(true);
    setStatusDefaultPassword(true);
  }

  const forgotpwd = async (username, userId, email, jsonData) => {
    let req = JSON.stringify({
      username,
      userId,
      email,
      ip: ip,
      device: clientInfo
    });

    await apiClient.post('api/usersmanage/forgetpassword', req
      , {
        headers: {
          'Authorization': `Bearer ${jsonData ? jsonData : token}`,
          'Content-type': 'application/json; charset=UTF-8'
        }
      })
      .then(data => {
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
      });
  }

  const handleResendEmail = () => {
    setLoading(true);
    let Token = cookie;
    let ExpiredDate = getExpiredDate(Token).toGMTString();
    let SendToken = Token + ";expires=" + ExpiredDate + ";path=/";

    var tokenReplace = SendToken.replace(/(?:(?:^|.*;\s*)__AntiXsrfUerkey\s*\=\s*([^;]*).*$)|^.*$/, "$1");
    var payload = parseJwt(tokenReplace);
    forgotpwd(payload.unique_name, payload.primarysid, payload.email)
  }

  const handleSocialLogin = (provider) => {
    if (!platformEnv) return; // Wait for config to load
    setError("");
    setLoading(true);

    const page = 'login'
    const stateObj = {
      provider,
      page,
      ...pid ? { pid } : {},
      ...type ? { type } : {}
    };
    const stateParam = encodeURIComponent(JSON.stringify(stateObj));
    let url = "";

    if (provider === "facebook") {
      url = `https://www.facebook.com/v17.0/dialog/oauth?client_id=${platformEnv.facebookId}&redirect_uri=${platformEnv.redirectUrl}&scope=email,public_profile&state=${stateParam}`;
    } else if (provider === "google") {
      url = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${platformEnv.googleId}&redirect_uri=${platformEnv.redirectUrl}&response_type=code&scope=email profile&state=${stateParam}`;
    } else if (provider === "line") {
      url = `https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=${platformEnv.lineId}&redirect_uri=${platformEnv.redirectUrl}&state=${stateParam}&scope=profile%20openid%20email`;
    }

    window.location.href = url;

  }

  const onCreateAccount = () => {
    if (pid) {
      history.push(
        { pathname: "/register", state: { type, pid } }
      )
    } else {
      history.push({ pathname: "/register" })
    }
  }

  const handleWarning = () => {
    setWarningModalCancel(() => () => setWarningModalVisible(false));
    setWarningModalOk(() => handleRequestOTP(token));
    setWarningModalVisible(true);
    setWarningModalMessage("Do you want to Resend OTP?");
  }

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleLogin(e);
    }
  }

  const handleChange = (e) => {
    const target = e.target;

    setErrormessage("");
    if (target.type === 'checkbox') {
      setModel((prevState) => ({ ...prevState, consent: target.checked }));
    } else {
      setModel((prevState) => ({ ...prevState, OTPcode: target.value }));
    }
  }

  useEffect(() => {
    apiClient.get("/api/PlatformEnv")
      .then((response) => {
        setPlatformEnv(response.data)
      })
      .catch((error) => {
        setLoading(false);
        setError(error.message);
      });
  }, []);

  useEffect(() => {
    utilIp()
    getClientInfo()
    getCookie("__AntiXsrfUerkey")
  }, [])

  return (
    <>
      {statusTwoFactor ? (
        <div style={{ padding: "50px" }}>
          <TwoFactor
            handleChange={handleChange}
            _handleKeyPress={handleKeyPress}
            errormessage={errormessage}
            state={model}
            setState={setModel}
            history={history}
            handleWarning={handleWarning}
            handleVerifyOTP={handleVerifyOTP}
            btnLoginloading={loading}
          />
        </div>
      ) : statusDefaultPassword ? (
        <div style={{ padding: "50px" }} className='d-flex justify-content-center'>
          <Col xs={24} md={24} lg={12} xl={12}>
            <ChangePassword
              state={model}
              btnLoginloading={loading}
              handleResendEmail={handleResendEmail}
            />
          </Col>
        </div>
      ) : (
        <Spin spinning={loading}>
          <div className='new-login-root'>
            {!isMobile ? <Banner page="login" /> : null}
            <div className='new-login-container'>
              <div className='new-login-header'>
                <div className='new-login-title'>Log in to your account</div>
                <div className='new-login-subtitle'>
                  <span>Don't have an account yet? </span>
                  <span className='new-login-create-account' onClick={onCreateAccount}>Create an account</span>
                </div>
              </div>
              <form className='new-login-form' onSubmit={handleLogin}>
                <div className="login-input-group">
                  <label className="login-label">Email</label>
                  <input
                    className="login-input"
                    placeholder="Email"
                    name="username"
                    value={form.username}
                    onChange={handleInputChange}
                    autoComplete="off"
                  />
                </div>
                <div className="login-input-group login-password-group">
                  <label className="login-label">Password</label>
                  <div className="login-password-wrapper">
                    <input
                      type={showPassword ? "text" : "password"}
                      className="login-input"
                      style={{ width: "100%" }}
                      name="password"
                      value={form.password}
                      onChange={handleInputChange}
                      placeholder="*********"
                      autoComplete="off"
                    />
                    <span className="login-eye-icon-wrapper" onClick={() => setShowPassword((v) => !v)}>
                      {showPassword ? (
                        <EyeInvisibleOutlined className="login-eye-icon" style={{ cursor: "pointer" }} />
                      ) : (
                        <EyeOutlined className="login-eye-icon" style={{ cursor: "pointer" }} />
                      )}
                    </span>
                  </div>
                </div>
                {error && <div className="login-error mt-3">{error}</div>}
                <button type='submit' className='new-login-login-btn'
                  disabled={!(form.username.trim() && form.password.trim())}
                >
                  Login
                </button>
              </form>
              <div className='new-login-divider'>
                <div className='new-login-divider-line'></div>
                <div className='new-login-divider-text'>Or</div>
                <div className='new-login-divider-line'></div>
              </div>
              <div className="login-social-btns">
                <button className="login-social-btn" disabled={loading} onClick={() => handleSocialLogin("google")}>
                  <img src={GoogleLogo} alt="Google" className="login-social-icon" />
                  <div className="login-social-btn-text">เข้าสู่ระบบด้วย Google</div>
                </button>
                {/* Hide Facebook login button for now */}
                {/* <button className="login-social-btn" disabled={loading} onClick={() => handleSocialLogin("facebook")}>
                  <img src={FacebookLogo} alt="Facebook" className="login-social-icon" />
                  <div className="login-social-btn-text">เข้าสู่ระบบด้วย Facebook</div>
                </button> */}
                <button className="login-social-btn" disabled={loading} onClick={() => handleSocialLogin("line")}>
                  <img src={LineLogo} alt="Line" className="login-social-icon" />
                  <div className="login-social-btn-text">เข้าสู่ระบบด้วย Line</div>
                </button>
              </div>
            </div>
          </div>
        </Spin >
      )}

      <ModalBroadCastWarning
        loading={loading}
        isVisible={warningModalVisible}
        message={warningModalMessage}
        onOk={warningModalOk}
        onCancel={warningModalCancel}
      />
    </>

  )
}

export default NewLogin